import { useState, useEffect } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { HeroSection } from "../components/HeroSection";
import { AboutSection } from "../components/AboutSection";
import { GallerySection } from "../components/GallerySection";
import { LocationSection } from "../components/LocationSection";
import { ContactSection } from "../components/ContactSection";
import { ReviewsSection } from "../components/ReviewsSection";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { FloatingWhatsApp } from "../components/FloatingWhatsApp";
import { CartModal, FloatingCart } from "../components/CartModal";
import { useLanguage, useSeoMeta } from "../i18n/LanguageContext";

export default function LandingPage() {
  const { t } = useLanguage();
  useSeoMeta({ title: t("seo.title"), description: t("seo.description"), keywords: t("seo.keywords") });
  const { scrollYProgress } = useScroll();
  const opacity = useTransform(scrollYProgress, [0, 0.1], [1, 0]);
  const [prefillMessage, setPrefillMessage] = useState("");

  const handleSelectJersey = (message) => {
    setPrefillMessage(message);
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-black" data-testid="landing-page">
      <Navbar />
      
      <main>
        <HeroSection />

        <AboutSection />
        <GallerySection onSelectJersey={handleSelectJersey} />
        <ReviewsSection />
        <LocationSection />
        <ContactSection prefillMessage={prefillMessage} />
      </main>
      
      <Footer />
      
      {/* Floating WhatsApp button */}
      <FloatingWhatsApp />
      <FloatingCart />
      <CartModal />
      
      {/* Scroll indicator */}
      <motion.div 
        style={{ opacity }}
        className="fixed bottom-8 left-1/2 -translate-x-1/2 z-40 flex flex-col items-center gap-2"
      >
        <span className="text-xs tracking-[0.2em] uppercase text-zinc-500 font-body">Scroll</span>
        <motion.div 
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="w-px h-8 bg-gradient-to-b from-[#009A49] to-transparent"
        />
      </motion.div>
    </div>
  );
}
